// extracted by mini-css-extract-plugin
export default {"proposalCollapsible":"proposalCollapsible-24d6"};